/**
 * Created by evgenijsenkevic on 11/8/25
 */

const GDComSocial = function () {
    Social.call(this, connector.GDCOM, {
        sdk: SdkManager.SDK_GDCOM
    });
};

GDComSocial.prototype = Object.create(Social.prototype);
GDComSocial.prototype.constructor = GDComSocial;

GDComSocial.isAppropriate = function () {
    return connector.platform.oneOf(connector.GDCOM) && connector.info.hybrid;
};

GDComSocial.prototype._connect = function (callback) {
    const player = new ConnectorActionPlayer([
        (f) => {
            f = connector.utils.waitNoMore(5000, f);

            if (this.storeReady) {
                f();
            } else {
                this.onStoreReady = f;
            }
        },

        (f, stop) => {
            if (typeof gdsdk !== "undefined" && typeof gdsdk.executeStoreAction === "function") {
                f();
            } else {
                stop();
            }
        },

        (f) => {
            if (!connector.platform.withTmpID()) {
                gdsdk.executeStoreAction({ action: "api.login" }).finally(f);
            } else {
                f();
            }
        },

        (f) => {
            gdsdk.executeStoreAction({ action: "api.loginInfo" })
                .then((info) => {
                    if (info.isLoggedIn && info.user) {
                        this.user = GDComSocial.formatUserData(info.user);
                    }
                    console.log("api.loginInfo: ", info);
                }).finally(f);
        }
    ]);

    player.onSuccess(() => {
        callback(connector.STATUS_CONNECTED);
    });

    player.onFailure(() => {
        callback(connector.STATUS_DISABLED);
    });

    player.play();
};

GDComSocial.prototype.onSdkEvent = function (event) {
    if (event.name === "STORE_READY") {
        this.storeReady = true;

        if (this.onStoreReady) {
            this.onStoreReady();
            delete this.onStoreReady;
        }
    } else if (event.name === "STORE_AFTER_AUTH") {
        const info = event.data;
        if (this.isConnected() && !this.loginRunning && !this.isLoggedIn() && info.isLoggedIn && info.user) {
            this.user = GDComSocial.formatUserData(info.user);
            this.onLogin();
        }
    }
};

GDComSocial.prototype._login = function (callback) {
    this.loginRunning = true;

    gdsdk.executeStoreAction({ action: "api.login" })
        .then((info) => {
            if (info.isLoggedIn && info.user) {
                this.user = GDComSocial.formatUserData(info.user);
            }
            console.log("api.login: ", info);
        })
        .finally(() => {
            this.loginRunning = false;
            callback && callback();
        });
};

GDComSocial.prototype.logout = function () {
    gdsdk.executeStoreAction({ action: "api.logout" }).then((info) => {
        console.log("api.logout: ", info);
    });

    this.user = undefined;
};

GDComSocial.prototype.isLoggedIn = function () {
    return this.user;
};

GDComSocial.prototype._getUserID = function () {
    return this.user && this.user.id;
};

GDComSocial.prototype.getAccessToken = function () {
    return "gdcom";
};

GDComSocial.prototype._aboutMe = function (callback) {
    if (this.user) {
        callback(connector.CODE_SUCCEED, this.user);
        return;
    }

    callback(connector.CODE_FAILED);
};

GDComSocial.formatUserData = function (user) {
    return {
        id: user.id,
        name: user.name || user.nickname || user.email,
        avatar: user.picture 
    };
};